import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'

@UntilDestroy()
@Component({
  selector: 'lla-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PageTitleComponent {
  @Input() title: string
  @Input() subTitle?: string
  @Input() extraClass = ''
  @Input() forOverview = false
}
